<template>
	<div id="apply_edit" class="issue_apply p_background user-select user-select clearfix">
		<h3 id="issue_title" class="all_title">更新应用</h3>
		<div id="container_box" class="container_box">

			<!--web 安装包 与 发布时间 start-->
			<div class="container-fluid">
				<div class="row">
					<!--web安装包 start-->
					<div class="col-sm-6 partition_message">
						<h4 class="message_title"><i class="must_color">*</i>应用镜像包</h4>
						<section class="install_box">
							<label class="file_text form_label">
	    					应用镜像包：
	    					</label>
							<div class="file_wrap inline-block pos-relative">
								<form>
									<div class="file_box">
										<input type="file" id="batchFile" @change="uploadWeb($event)" />
									</div>
									<i class="glyphicon ico_del" @click="delPackage($event)"></i>
									<span class="file_name text-space" data-toggle="tooltip" data-placement="bottom" :title="webfileorignalname">{{webfileorignalname}}</span>
								</form>
							</div>

							<div class="progress progress-striped active" style="display: none">
								<div id="progressBar" class="progress-bar progress-bar-info" role="progressbar" aria-valuemin="0" aria-valuenow="0" aria-valuemax="100" style="width: 0%">
								</div>
							</div>
						</section>
					</div>
					<!--web安装包 end-->

					<!--发布时间 start-->
					<div class="col-sm-6 partition_message">

						<section class="issue_time_box partition_message">
							<h4 class="message_title"><i class="must_color">*</i>发布时间</h4>
							<div class="issue_time_container">
								<div class="container-fluid">
									<div class="row publick_form_box">

										<!--发布时间-->
										<section class="form_box">
											<label class="form_label content_block" for="">发布时间：</label>
											<div class="issue_time_radio_box content_block pd_l27">
												<div class="issue_time_radio">
													<input type="radio" class="radio_input_y" name="radio_issue_time" id="issue_time_radio" @click="openSub(1)" value="1" v-model="tCloudAppVersion.publishType" />
													<label class="form_label radio_label" for="issue_time_radio">审核后立即发布</label>
												</div>
												<div class="issue_time_radio">
													<input type="radio" class="radio_input_y" name="radio_issue_time" id="issue_time_radio1" @click="openSub(2)" value="2" v-model="tCloudAppVersion.publishType" />
													<label class="form_label radio_label" for="issue_time_radio1">定时发布</label>
													<div class="time_option" style="display: none;">
														<el-date-picker v-model="tCloudAppVersion.publishTime" type="datetime" placeholder="选择日期时间">
														</el-date-picker>
													</div>
												</div>
												<div class="issue_time_radio">
													<input type="radio" class="radio_input_y" name="radio_issue_time" id="issue_time_radio2" value="3" @click="openSub(3)" v-model="tCloudAppVersion.publishType" />
													<label class="form_label radio_label" for="issue_time_radio2">审核后手动确认</label>
												</div>
											</div>
										</section>

									</div>
								</div>
							</div>
						</section>

					</div>
					<!--发布时间 end-->
				</div>
			</div>
			<!--web 安装包 与 发布时间 end-->

			<!--版本 与 版本更新说明 start-->
			<div class="container-fluid">
				<div class="row">
					<!--版本更新说明 start-->
					<div class="col-sm-6 partition_message">
						<h4 class="message_title"><i class="must_color">*</i>版本更新说明</h4>
						<section class="explain_box">
							<textarea name="" v-model="tCloudAppVersion.versionComment" @change="valdata1()" class="form-control" rows="10" placeholder="简介(字数不少于20字且最多500字)"></textarea>
						</section>
					</div>
					<!--版本更新 end-->

					<!--版本 start-->
					<div class="col-sm-6 partition_message">
						<h4 class="message_title">版本</h4>
						<section class="install_box" v-for="list in versionList">
							<p>{{list.versionNo}}</p>
						</section>
					</div>
					<div class="progress progress-striped active" style="display: none">
						<div id="progressBar" class="progress-bar progress-bar-info" role="progressbar" aria-valuemin="0" aria-valuenow="0" aria-valuemax="100" style="width: 0%">
						</div>
					</div>
					<!--版本 end-->
				</div>
			</div>
			<!--版本 与 版本更新说明 end-->

			<!--基本信息 start-->
			<section class="basic_message partition_message">
				<h4 class="message_title"><i class="must_color">*</i>基本信息</h4>
				<div class="basic_container">
					<div class="container-fluid">
						<div class="row publick_form_box">

							<!--应用名称-->
							<section class="form_box">
								<label class="form_label" for=""><i class="must_color">*</i>应用名称：</label>
								<input type="text" id="issue_applyName" v-model="tCloudApp.appName" disabled="disabled" class="form-control form_control" placeholder="应用名称最多输入20个汉字" />
								<span class="tip_sub_text text_margin_left">(上线不能修改应用名称)</span>
							</section>

							<!--应用英文名称-->
							<section class="form_box">
								<label class="form_label" for=""><i class="must_color">*</i>应用英文名称：</label>
								<input type="text" id="issue_applyEnName" v-model="tCloudApp.appEnName" disabled="disabled" class="form-control form_control" placeholder="应用名称最多输入20个英文字母" />
							</section>

							<!--版本编号-->
							<section class="form_box">
								<label class="form_label" for=""><i class="must_color">*</i>版本编号：</label>
								<input type="text" id="issue_applyNumber" v-model="tCloudAppVersion.versionNo" @change="valdataVersionNo()" maxlength="20" class="form-control form_control" />
								<span class="tip_sub_text text_margin_left">(与安装包版本一致)</span>
							</section>

							<!--应用分类-->
							<section class="form_box">
								<label class="form_label" for=""><i class="must_color">*</i>应用分类：</label>
								<select v-model="tCloudApp.businessType" id="issue_select" disabled="disabled" class="form-control form_control">
									<option value="">请选择分类</option>
									<option v-for="option in appTypeOptions" v-bind:value="option.id">
										{{ option.dictionaryname }}
									</option>
								</select>
							</section>

							<!--群体范围-->
							<section id="issue_checkbox" class="form_box line_block">
								<label class="form_label" for=""><i class="must_color">*</i>群体范围：</label>
								<div class="radio_box" v-for="(range,index) in appRange">
									<input type="checkbox" class="radio_input_f" :id="'rangid'+index" disabled="disabled" name="group_radio" :value="range.id" v-model="rangeCheck" />
									<label class="form_label radio_label" :for="'rangid'+index">{{range.dictionaryname}}</label>
								</div>
							</section>

							<!--增值服务-->
							<section id="issue_checkbox1" class="form_box line_block">
								<label class="form_label" for=""><i class="must_color">*</i>增值服务：</label>
								<div class="radio_box" v-for="(addservices,index) in appAddServices">
									<input type="checkbox" class="radio_input_f" :id="'addservicesid'+index" disabled="disabled" name="group_radio" :value="addservices.id" v-model="addservicesCheck" />
									<label class="form_label radio_label" :for="'addservicesid'+index">{{addservices.dictionaryname}}</label>
								</div>
							</section>

							<!--数据接口权限-->
							<section id="issue_checkbox2" class="form_box line_block">
								<label class="form_label" for=""><i class="must_color">*</i>数据接口权限：</label>
								<div class="radio_box" v-for="(interface,index) in appInterface">
									<input type="checkbox" class="radio_input_f" :id="'interfaceid'+index" disabled="disabled" name="group_radio" :value="interface.id" v-model="interfaceCheck" />
									<label class="form_label radio_label" :for="'interfaceid'+index">{{interface.dictionaryname}}</label>
								</div>
							</section>

							<!--部署类型-->
							<section id="deploy_type" class="form_box line_block">
								<label class="form_label" for=""><i class="must_color">*</i>部署类型：</label>
								<div class="radio_box" v-for="(deploytypech,index) in deployType">
									<input type="radio" class="radio_input_y" :id="'deploytypeid'+index" disabled="disabled" name="group_radio" :value="deploytypech.id" v-model="tCloudApp.deployType" />
									<label class="form_label radio_label" :for="'deploytypeid'+index">{{deploytypech.dictionaryname}}</label>
								</div>
							</section>

							<!--支持客户端-->
							<section id="client_type" class="form_box line_block">
								<label class="form_label" for=""><i class="must_color">*</i>支持客户端：</label>
								<div class="radio_box" v-for="(clienttypech,index) in clientType">
									<input type="checkbox" class="radio_input_f" :id="'clienttypech'+index" name="group_radio_range" :value="clienttypech.id" v-model="clientTypeArray" />
									<label class="form_label radio_label" :for="'clienttypech'+index">{{clienttypech.dictionaryname}}</label>
								</div>
							</section>

							<!--窗口打开方式-->
							<section id="window_type" class="form_box line_block">
								<label for="" class="form_label">
									<span class="must_color">*</span>
									窗口打开方式：
								</label>
								<div class="radio_box">
									<input name="open_window" class="radio_input_y" type="radio" id="newwindow" value="1" v-model="tCloudAppVersion.openType" @change="newwindow()" />
									<label for="newwindow" class="radio_label form_label">新窗口</label>
								</div>
								<div class="radio_box">
									<input name="open_window" class="radio_input_y" type="radio" id="newinternal" value="2" v-model="tCloudAppVersion.openType" @change="newwindow1()" />
									<label for="newinternal" class="radio_label form_label">内置窗口</label>
								</div>
								<div class="window_size inline-block-3" v-if="tCloudAppVersion.openType == '2'">
									<section>
										<span>宽</span>
										<input type="text" class="form-control small_input" v-model="tCloudAppVersion.windowWidth" />
										<span>px;</span>
									</section>
									<section>
										<span>高</span>
										<input type="text" class="form-control small_input" v-model="tCloudAppVersion.windowHeight" />
										<span>px</span>
									</section>
								</div>
							</section>

							<!--应用介绍-->
							<section class="form_box">
								<label class="form_label" for=""><i class="must_color">*</i>应用介绍：</label>
								<textarea name="" id="issue_textarea" v-model="tCloudAppVersion.appComment" class="form-control form_textarea" rows="5" placeholder="简介(字数不少于60字且最多五百字)"></textarea>
							</section>

						</div>
					</div>
				</div>
			</section>
			<!--基本信息 end-->

			<!--图标素材 start-->
			<section class="material_icon_box partition_message">
				<h4 class="message_title"><i class="must_color">*</i>图标素材</h4>
				<div class="material_icon_container">
					<div class="container-fluid">
						<div class="row publick_form_box">
							<section class="col-sm-6">
								<span class="file_text">
		    					应用图标：
		    				</span>
								<div class="file_box" :style="{backgroundImage : 'url('+ fileImg + ')'}">
									<form id="subform" enctype="multipart/form-data" method="post" action="/zklccloud/uploadImages">
										<input type="file" name="file" :class="{'vis-hide': classVisFlag}" @click="disabledF($event)" @change="uploadImage($event)">
										<input type="hidden" name="type" value="2">
									</form>
								</div>
								<div class="tip_text">
									<p>要求：</p>
									<p>1.等边矩形</p>
									<p>2.PNG、JPG</p>
									<p>3.尺寸≥512px</p>
									<p>4.不超过1M</p>
								</div>
							</section>
							<section class="col-sm-3">
								<h5>更多尺寸：</h5>
								<div class="row more_content text-center">
									<a class="col-sm-6" :href="icon.filePath" v-for="icon in icolist" target="_blank">{{icon.viewSize}}*{{icon.viewSize}}</a>
								</div>
							</section>
						</div>
					</div>
				</div>
			</section>
			<!--图标素材 end-->

			<!--应用截图 start-->
			<section class="screenshot_box partition_message">
				<h4 class="message_title"><i class="must_color">*</i>应用截图</h4>
				<div class="screenshot_container">
					<div class="container-fluid">
						<div class="row publick_form_box">
							<p>
								<small class="tip_small_text">请上传2-5张图片,大于500px,格式PNG\JPG,2M以内大小</small>
							</p>
							<div class="img_box pos-relative" v-for="(path,index) in paths" v-show="path.length!=0">
								<img v-bind:src="path" />
								<i class="glyphicon ico_del" @click="delImg(index)"></i>
							</div>
							<div class="file_box" v-show="paths.length<=5">
								<form>
									<input type="file" name="file" id="addAppImage" @change="addAppImage()" />
								</form>
							</div>
						</div>
					</div>
				</div>
			</section>
			<!--应用截图 end-->

			<!--授权类型 start-->
			<!--授权类型 start-->
			<section class="authorization_box partition_message">
				<h4 class="message_title"><i class="must_color">*</i>授权类型</h4>
				<div class="authorization_container">
					<div class="container-fluid">
						<div class="row publick_form_box">

							<section class="form_box line_block">
								<label class="form_label" for="">授权类型：</label>
								<div class="radio_box">
									<input type="radio" class="radio_input_y" id="radio_authorization2" name="radio_authorization" v-model="tCloudApp.authType" @click="authorizationBoxShow($event)" value="1" />
									<label class="form_label radio_label" for="radio_authorization2">公开发布</label>
								</div>
								<div class="radio_box">
									<input type="radio" class="radio_input_y " id="radio_authorization1" name="radio_authorization" v-model="tCloudApp.authType" @click="authorizationBoxShow($event)" value="2" />
									<label class="form_label radio_label" for="radio_authorization1">隐私发布</label>
								</div>
							</section>

							<section id="radio_authorization_form_box" class="form_box text-center" style="display: none;">
								<label for="" class="form_label">授权码</label>
								<input type="text" class="form-control form_control" disabled="disabled" name="" id="" value="" v-model="tCloudApp.authCode" placeholder="请输入授权码" />
								<i class="glyphicon icon_reload" @click="authorizationBoxShow()"></i>
								<p class="tip_sub_text hint_small_left">
									<small>(不在应用库中显示,通过搜索授权码显示)</small>
								</p>
							</section>

						</div>
					</div>
				</div>
			</section>
			<!--授权类型 end-->
			<!--			<p class="tip_sub_text partition_message text-center">
				内容已于
				<span>2016年12月2日 14:37分</span> 自动保存
			</p>
-->
			<div class="btn_box text-center partition_message">
				<span id="save_app_btn" class="btn btn_submit" @click="doSubmit($event)">保存</span>
				<span id="inspect_app_btn" class="btn btn_submit" @click="doSubmit($event)" v-if="!hidsub">提交审核</span>
			</div>
		</div>

	</div>
</template>

<script>
	import { MessageBox } from 'element-ui'
	export default {
		name: 'issue_apply',
		data() {
			return {
				versionList:[],
				doubleClick: false,
				disabledFlag: false,
				classVisFlag: false,
				fileImg: '',
				bussiness: '',
				hidsub: false,
				gonext: false,
				paths: [],
				value1: '',
				appTypeOptions: '',
				selected: '',
				appRange: '',
				appInterface: '',
				appAddServices: '',
				deployType: '',
				rangeCheck: [],
				interfaceCheck: [],
				addservicesCheck: [],
				images: [],
				imagesfile: '',
				icolist: [],
				appImage: [],
				appVersionList: [],
				appId: '',
				appVersionId: '',
				group_radio_range: [],
				clientType: '',
				clientTypeArray: [],
				webfileorignalname: '',
				addLists: [],
				tCloudApp: {
					id: '',
					appName: '',
					appEnName: '',
					appType: '',
					businessType: '',
					deployType: '',
					appClinetid: '',
					appClinetsercet: '',
					appversionid: '',
					uploadUser: '',
					specialType: '',
					delFlag: '',
					authCode: '',
					authType: '',
					inputTime: '',
					inputUser: '',
					updateTime: '',
					updateUser: ''
				},
				tCloudAppVersion: {
					id: '',
					appid: '',
					versionNo: '',
					appComment: '',
					appInstallpackagePath: '',
					versionComment: '',
					publishTime: '',
					misdataApis: '',
					addserviceApis: '',
					visitUrl: '',
					userScope: '',
					inspectStatus: '',
					publishStatus: '',
					delFlag: '',
					inputTime: '',
					inputUser: '',
					updateTime: '',
					updateUser: '',
					publishType: '',
					appVersionIconFilePath: '',
					appVersionApplyFilePath: '',
					openType: '',
					windowWidth: '700',
					windowHeight: '500',
					clientType: ''
				}
			}
		},
		created: function() {
			//应用id
			this.appId = this.$route.params.appid;
			//应用id
			this.appVersionId = this.$route.params.appVersionId;
			//查看应用信息
			this.getTCloudApp();
			this.getTCloudAppVersion();
			this.getSystemConfigList();
			this.getVersionFile();
			this.getPriceList();
		},
		computed: {

		},
		mounted: function() {
			this.$nextTick(function() {
				this.fileImg = require('../assets/images/ico-add.png');
			})
		},
		methods: {
			getSystemConfigList() {
				var temp = this;
				this.$http.post('/zklccloud/queryAllTCloudSysDictionary', {
					emulateJSON: true
				}).then(function(m) {
					for(var key in m.body.dictionaryMap) {
						if(key == '应用分类') {
							temp.appTypeOptions = m.body.dictionaryMap[key];
							if(null != temp.bussiness && '' != temp.bussiness) {
								temp.tCloudApp.businessType = temp.bussiness;
							}
						} else if(key == '群体范围') {
							temp.appRange = m.body.dictionaryMap[key];
						} else if(key == '增值服务') {
							temp.appAddServices = m.body.dictionaryMap[key];
						} else if(key == '数据接口权限') {
							temp.appInterface = m.body.dictionaryMap[key];
						} else if(key == '部署类型') {
							temp.deployType = m.body.dictionaryMap[key];
						} else if(key == '支持客户端') {
							temp.clientType = m.body.dictionaryMap[key];
						}
					}
				})
			},
			getTCloudApp() {
				var temp = this;
				if(null == temp.appId || '' == temp.appId) {
					return false;
				}
				this.$http.post('/zklccloud/findByAppid', {
					"appId": temp.appId
				}, {
					emulateJSON: true
				}).then(function(m) {
					if(m.body.resultCode == '0') {
						temp.tCloudApp = m.body.content.tCloudApp;
						if(temp.tCloudApp.authCode != '' && temp.tCloudApp.authCode != null) {
							$("#radio_authorization_form_box").slideDown();
						}
						temp.bussiness = m.body.content.tCloudApp.businessType;
					} else {
						MessageBox('查询失败！', '提示', 'error', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
					}
				})
			},
			getTCloudAppVersion() {
				var temp = this;
				if(null == temp.appId || '' == temp.appId) {
					return false;
				}
				this.$http.post('/zklccloud/findTCloudAppVersionListById', {
					"appid": temp.appId
				}, {
					emulateJSON: true
				}).then(function(m) {
					temp.versionList = m.body.content.appVersionList;
					for(var i = 0; i < m.body.content.appVersionList.length; i++) {
						temp.appVersionList.push(m.body.content.appVersionList[i].versionNo);
						if(temp.appVersionId == m.body.content.appVersionList[i].id) {
							temp.tCloudAppVersion = m.body.content.appVersionList[i];
							temp.tCloudAppVersion.id = '';
							temp.tCloudAppVersion.publishType = '';
							temp.tCloudAppVersion.versionComment = '';
							temp.tCloudAppVersion.publishTime = '';
							temp.tCloudAppVersion.versionNo = '';
							temp.tCloudAppVersion.appInstallpackagePath = '';
							temp.clientTypeArray = temp.tCloudAppVersion.clientType.split(",");
							for(var i = 0; i < temp.tCloudAppVersion.userScope.split(",").length; i++) {
								temp.rangeCheck.push(temp.tCloudAppVersion.userScope.split(",")[i]);
							}
							for(var i = 0; i < temp.tCloudAppVersion.misdataApis.split(",").length; i++) {
								temp.interfaceCheck.push(temp.tCloudAppVersion.misdataApis.split(",")[i]);
							}
							for(var i = 0; i < temp.tCloudAppVersion.addserviceApis.split(",").length; i++) {
								temp.addservicesCheck.push(temp.tCloudAppVersion.addserviceApis.split(",")[i]);
							}
						}
					}
				})
			},
			getVersionFile() {
				var temp = this;
				if(null == temp.appId || '' == temp.appId) {
					return false;
				}
				this.$http.post('/zklccloud/findTCloudAppFilesByVersionId', {
					"appversionid": temp.appVersionId
				}, {
					emulateJSON: true
				}).then(function(m) {
					for(var i = 0; i < m.body.content.appFiles.length; i++) {
						if(m.body.content.appFiles[i].fileType == '108001') {
							temp.icolist.push(m.body.content.appFiles[i]);
							temp.fileImg = m.body.content.appFiles[0].filePath;
						} else {
							temp.paths.push(m.body.content.appFiles[i].filePath);
						}
					}
				})
			},
			doSubmit(e) {
				e = e || window.event;
				var temp = this;
				if($(e.target).html() == '保存') {
					this.tCloudAppVersion.inspectStatus = 'up';
				} else {
					this.tCloudAppVersion.inspectStatus = 'pu';
				}
				this.tCloudAppVersion.userScope = this.rangeCheck.join(",");
				this.tCloudAppVersion.addserviceApis = this.addservicesCheck.join(",");
				this.tCloudAppVersion.misdataApis = this.interfaceCheck.join(",");
				var s = new Array;
				for(var i = 0; i < this.icolist.length; i++) {
					var icon = this.icolist[i];
					s.push(icon.viewSize + "-" + icon.filePath)
				}
				this.tCloudAppVersion.appVersionIconFilePath = s.join(",");
				this.tCloudAppVersion.appVersionApplyFilePath = this.paths.join(",");
				this.tCloudAppVersion.clientType = this.clientTypeArray.join(",");

				var name = $("#issue_applyName"),
					nameEn = $("#issue_applyEnName"),
					appNum = $("#issue_applyNumber"),
					issueSelect = $("#issue_select"),
					checkBox = $("#issue_checkbox"),
					checkBox1 = $("#issue_checkbox1"),
					checkBox2 = $("#issue_checkbox2"),
					dateBox = $("#issue_date_box");
				if(!this.gonext) {
					MessageBox('编号只允许小写英文和数字以及“.”,限20字符以内', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				}

				if((/[^0-9\u4E00-\u9FA5]/g.test(name.val())) || '' == name.val()) {
					MessageBox('应用名称只允许中文及数字,限40个字符以内', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						name.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if(/[^a-zA-Z0-9]/g.test(nameEn.val()) || '' == nameEn.val()) {
					MessageBox('英文名称最多输入60个字符，只允许英文和数字', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						nameEn.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if(/[^a-z0-9.]/g.test(appNum.val()) || '' == appNum.val()) {
					MessageBox('编号只允许小写英文和数字以及“.”,限20字符以内', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						appNum.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if(issueSelect.find("option:selected").val() == "" || issueSelect.find("option:selected").val() == null) {
					MessageBox('请选择应用分类', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if(checkBox.find("input[type='checkbox']:checked").length === 0) {
					MessageBox('群体范围项最少为一项', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if(checkBox1.find("input[type='checkbox']:checked").length === 0) {
					MessageBox('增值服务项最少为一项', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if(checkBox2.find("input[type='checkbox']:checked").length === 0) {
					MessageBox('数据接口权限项最少为一项', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if(null == this.tCloudAppVersion.appComment || '' == this.tCloudAppVersion.appComment) {
					MessageBox('应用介绍不能为空', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if(20 > this.tCloudAppVersion.appComment.length) {
					MessageBox('应用介绍描述字数小于20', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if(null == this.tCloudAppVersion.appInstallpackagePath || '' == this.tCloudAppVersion.appInstallpackagePath) {
					MessageBox('请上传应用包', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if(null == this.tCloudAppVersion.versionComment || '' == this.tCloudAppVersion.versionComment) {
					MessageBox('版本介绍不能为空', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if(20 > this.tCloudAppVersion.versionComment.length) {
					MessageBox('版本介绍描述字数小于20', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if(null == this.tCloudAppVersion.publishType || '' == this.tCloudAppVersion.publishType) {
					MessageBox('请选择发布时间', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if(this.tCloudAppVersion.publishType == '2' && ('' == this.tCloudAppVersion.publishTime || null == this.tCloudAppVersion.publishTime)) {
					MessageBox('请选择定时发布时间', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if(null == this.tCloudAppVersion.appVersionIconFilePath || '' == this.tCloudAppVersion.appVersionIconFilePath) {
					MessageBox('请上传图标', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if(null == this.tCloudAppVersion.appVersionApplyFilePath || '' == this.tCloudAppVersion.appVersionApplyFilePath) {
					MessageBox('请上传截图', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if(this.paths.length < 2) {
					MessageBox('请上传多于2张的截图', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if(null == this.tCloudApp.authType || '' == this.tCloudApp.authType) {
					MessageBox('请选择授权类型', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if(null == this.tCloudApp.deployType || '' == this.tCloudApp.deployType) {
					MessageBox('请选择部署类型', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if(null == this.tCloudAppVersion.openType || '' == this.tCloudAppVersion.openType) {
					MessageBox('请选择打开方式', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if(this.tCloudAppVersion.openType == '2' && (null == this.tCloudAppVersion.windowWidth || '' == this.tCloudAppVersion.windowWidth)) {
					MessageBox('请输入宽度', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if(this.tCloudAppVersion.openType == '2' && (null == this.tCloudAppVersion.windowHeight || '' == this.tCloudAppVersion.windowHeight)) {
					MessageBox('请输入高度', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if(null == this.tCloudAppVersion.clientType || '' == this.tCloudAppVersion.clientType) {
					MessageBox('请选择支持客户端', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else {
					var formData = JSON.stringify(temp.addLists);
					var parameter = {
						"tcloudapp": this.tCloudApp,
						"tcloudappversion": this.tCloudAppVersion,
						"jsonStr": formData
					};
					if(!this.doubleClick){
						this.doubleClick = true;
							this.$http.post('/zklccloud/saveTCloudApp', JSON.stringify(parameter)).then(function(data) {
							this.doubleClick = false;
							if(data.body.resultCode == '0') {
								this.$alert('操作成功！', '提示', 'success', {
									confirmButtonText: '确定',
								}).then(() => {
									temp.$router.push({
										path: '/all_app'
									});
								});
	
								if($(".el-message-box__btns")) {
									$(".el-message-box__btns").attr("id", "btnSub");
								}
							} else {
								this.$alert('操作失败！', '提示', 'error', {
									confirmButtonText: '确定',
								});
	
								if($(".el-message-box__btns")) {
									$(".el-message-box__btns").attr("id", "btnSub");
								}
							}
						}).catch(function() {
							this.doubleClick = false;
							this.$alert('操作失败！', '提示', 'error', {
								confirmButtonText: '确定',
							});
						});
					}
					
				}
			},
			uploadImage: function(e) {
				e = e || window.event;
				var temp = this;
				$("#subform").ajaxSubmit(function(data) {
					if(data.resultCode == '0') {
						MessageBox('操作成功！', '提示', 'success', {
							confirmButtonText: '确定',
						});
						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						temp.icolist = data.content.filepath;
						temp.fileImg = temp.icolist[0].filePath;
						temp.classVisFlag = false;
					} else {
						temp.classVisFlag = false;
						if(data.content.filepath == "#nottype#") {
							MessageBox('操作失败，请检查附件大小和类型！', '提示', 'warning', {
								confirmButtonText: '确定',
							});
							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
						} else {
							MessageBox('操作失败，请上传等边矩形且尺寸>=512的图片', '提示', 'warning', {
								confirmButtonText: '确定',
							});
							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
						}

					}
				});
			},
			addAppImage: function(e) {
				e = e || window.event;
				var temp = this;
				var fileObj = e.target.files || e.dataTransfer.files; // js 获取文件对象
				var FileController = '/zklccloud/uploadImages'; // 接收上传文件的后台地址 
				// FormData 对象
				var form = new FormData();
				form.append("file", fileObj[0]); // 文件对象
				form.append("type", "1");
				var xhr = new XMLHttpRequest();
				xhr.open("post", FileController, true);
				xhr.onload = function() {
					var ttt = eval('(' + xhr.responseText + ')');
					if(ttt.resultCode == '0') {
						temp.paths.push(ttt.content.filepath);
					} else {
						MessageBox('操作失败，请检查附件大小和类型！', '提示', 'error', {
							confirmButtonText: '确定',
						});
						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
					}
				};
				xhr.send(form);
			},
			uploadWeb: function(e) {
				e = e || window.event;
				// 进度条归零发
				$("#progressBar").width("0%");
				// 上传按钮禁用
				$("#uploadBtn").attr("disabled", true);
				// 进度条显示
				$("#progressBar").parent().show();
				$("#progressBar").parent().addClass("active");
				var files = e.target.files || e.dataTransfer.files;
				this.upload(e);
			},
			upload: function(e) {
				e = e || window.event;
				var temp = this;
				var fileObj = $("#batchFile").get(0).files[0]; // js 获取文件对象
				var FileController = '/zklccloud/upload'; // 接收上传文件的后台地址 
				// FormData 对象
				var form = new FormData();
				form.append("file", fileObj); // 文件对象
				form.append("access_token",localStorage.getItem('token'));
				// XMLHttpRequest 对象
				var xhr = new XMLHttpRequest();
				xhr.open("post", FileController, true);
				xhr.onload = function() {
					// ShowSuccess("上传完成");
					var ttt = eval('(' + xhr.responseText + ')');
					MessageBox('上传完成！', '提示', 'success', {
						confirmButtonText: '确定',
					});
					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					$("#batchUploadBtn").attr('disabled', false);
					$("#batchUploadBtn").val("上传");
					$("#batchFile").parent().addClass("file_box_c");
					$("#progressBar").parent().removeClass("active");
					$("#progressBar").parent().hide();
					temp.tCloudAppVersion.appInstallpackagePath = ttt.content.filepath;
					temp.webfileorignalname = ttt.content.originalFilename;

				};
				xhr.upload.addEventListener("progress", this.progressFunction, false);
				xhr.send(form);
			},
			progressFunction: function(evt) {
				var progressBar = $("#progressBar");
				if(evt.lengthComputable) {
					var completePercent = Math.round(evt.loaded / evt.total * 100) + "%";
					progressBar.width(completePercent);
					$("#batchUploadBtn").val("正在上传 " + completePercent);
				}
			},
			valdata1: function(e) {
				e = e || window.event;
				if($(e.target).val().length < 20) {
					MessageBox('20到500个字符', '提示', 'warning', {
						confirmButtonText: '确定',
					});
					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if($(e.target).val().length > 500) {
					MessageBox('20到500个字符', '提示', 'warning', {
						confirmButtonText: '确定',
					});
					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					this.tCloudAppVersion.versionComment = $(e.target).val().substring(0, 500);
					return false;
				}
			},
			authorizationBoxShow: function(e) {
				var temp = this;
				var radioBox = document.getElementById("radio_authorization1");
				if(radioBox.checked) {
					$("#radio_authorization_form_box").slideDown()
					this.$http.post('/zklccloud/queryAuthCode', {
						emulateJSON: true
					}).then(function(m) {
						if(m.body.resultCode == '0') {
							temp.tCloudApp.authCode = m.body.content.authCode;
						} else {
							MessageBox('查询失败！', '提示', 'error', {
								confirmButtonText: '确定',
							});
							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
						}
					})
				} else {
					temp.tCloudApp.authCode = '';
					$("#radio_authorization_form_box").slideUp()
				}
			},
			openSub: function(type) {
				this.tCloudAppVersion.publishType = type;
				if(type == '2') {
					$(".time_option").css("display", "inline-block");
				} else {
					this.tCloudAppVersion.publishTime = '';
					$(".time_option").css("display", "none");
				}
			},
			delImg: function(index) {
				this.paths.splice(index, 1)
			},
			delPackage: function(e) {
				$(e.target).siblings(".file_box").removeClass("file_box_c");
				$(e.target).siblings(".file_box").html('<input type="file" id="batchFile" @change="uploadWeb()" date=' + new Date() + '/>');
				this.tCloudAppVersion.appInstallpackagePath = '';
			},
			valdataVersionNo: function(e) {
				e = e || window.event;
				var appNum = $("#issue_applyNumber");
				if(/[^a-z0-9.]/g.test(appNum.val()) || '' == appNum.val()) {
					this.tCloudAppVersion.versionNo = '';
					MessageBox('编号只允许小写英文和数字以及“.”,限20字符以内', '提示', 'warning', {
						confirmButtonText: '确定',
					});
					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				}
				this.$http.post('/zklccloud/queryVersionNo', {
					"versionNo": $(e.target).val(),
					"appId": this.appId,
					"appVersionId": this.appVersionId
				}, {
					emulateJSON: true
				}).then(function(m) {
					if(m.body.resultCode == '0') {
						this.gonext = true;
					} else {
						this.tCloudAppVersion.versionNo = '';
						MessageBox('版本号冲突！', '提示', 'warning', {
							confirmButtonText: '确定',
						});
						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						$(e.target).val('');
						return false;
					}
				})
			},
			newwindow: function(e) {
				this.tCloudAppVersion.windowWidth = '';
				this.tCloudAppVersion.windowHeight = '';
			},
			newwindow1: function(e) {
				if(this.tCloudAppVersion.windowWidth == "" || this.tCloudAppVersion.windowHeight == "") {
					this.tCloudAppVersion.windowWidth = '700';
					this.tCloudAppVersion.windowHeight = '500';
				}
			},
			disabledF() {
				this.classVisFlag = true;
				var temp = this;
				setTimeout(function() {
					temp.classVisFlag = false;
				}, 2000)
			},
			getPriceList(){
				var temp = this;
				if(null == temp.appId || '' == temp.appId || 'undefined' == temp.appId) {
					return false;
				}
				this.$http.post('/zklccloud/findPriceListByAppId', {
					"appId": temp.appId
				}, {
					emulateJSON: true
				}).then(function(m) {
					if(m.body.resultCode == '0') {
						if(!m.body.content.priceList.length){
							temp.addLists = [];
							//temp.addOperation();
						}else{
							temp.costFlag = false;
							temp.addLists = m.body.content.priceList;
						}
					}
				})
			},
			addOperation(){
				var temp = this;
				var newObj = {};
				newObj.money = "";
				newObj.timeLimit = "";
				newObj.minNum = "";
				newObj.maxNum = "";
				temp.addLists.push(newObj);
				temp.costFlag = true;
			},

		},
	}
</script>

<style scoped>
.content_block {
	display: block!important;
}
.pd_l27 {
	padding-left: 27%;
}
</style>


// WEBPACK FOOTER //
// edit_app.vue?76a6c158